/**
 * Which row's table-name editor is open after a row asks to open or close its own.
 * Opening takes this row. Closing clears the open row only when it is this one, so a
 * late close from a row whose editor another row already replaced changes nothing.
 */
export function nextEditingName(
  current: string | null,
  rowName: string,
  open: boolean,
): string | null {
  if (open) return rowName;
  return current === rowName ? null : current;
}
